import { useCallback } from "react";
import { useReviewTranslationContext } from "./ReviewTranslationContext";

export const useReviewTranslation = (reviewId) => {
  const context = useReviewTranslationContext();

  if (!context || Object.keys(context).length === 0) {
    throw new Error(
      "useReviewTranslation must be used within ReviewTranslationProvider",
    );
  }

  const {
    getReviewTranslationState,
    setReviewTranslationState,
    clearReviewTranslationState,
  } = context;

  const state = getReviewTranslationState(reviewId);
  const showTranslatedReview = state.showTranslated;
  const translation = state.translation;

  const setTranslation = useCallback(
    (translationData, showTranslated = false) => {
      setReviewTranslationState(reviewId, {
        translation: translationData,
        showTranslated,
      });
    },
    [reviewId, setReviewTranslationState],
  );

  const toggleShowTranslated = useCallback(
    (shouldShow) => {
      setReviewTranslationState(reviewId, {
        translation,
        showTranslated:
          shouldShow !== undefined ? shouldShow : !showTranslatedReview,
      });
    },
    [reviewId, translation, showTranslatedReview, setReviewTranslationState],
  );

  const clearTranslation = useCallback(() => {
    clearReviewTranslationState(reviewId);
  }, [reviewId, clearReviewTranslationState]);

  return {
    showTranslatedReview,
    translation,
    setTranslation,
    toggleShowTranslated,
    clearTranslation,
  };
};
